/// <reference path="../../../../../../typings/index.d.ts" />
module Meevo.Plugins.RatingsControlPanel {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class RatingsSummaryViewController implements ng.IComponentController {
        public get objectStateEnum(): typeof ObjectStateEnum{
            return ObjectStateEnum;
        }

        public ratingMap(value) {
            return value ? value : 0;
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .component('meevoRatingsControlPanelSummaryViewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/ratingsControlPanel/components/summaryView/ratings-summary-view.template.html',
            controller: RatingsSummaryViewController,
            controllerAs: '$ctrl',
            bindings: {
                items: '=',
            }
        });
}
